import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import { Typography } from 'carbon-react/lib/components/typography/typography.component';

import { matchConsolidationDetailRoutePath } from '@futrli/shared-services';

import { CreateConsolidatedForecastWizardContextProvider } from '../contexts/create-consolidated-forecast-wizard-context';
import { CreateConsolidatedThreeWayForecastContainer } from '../containers/create-consolidated-3-way-forecast-wizard-container/create-consolidated-three-way-forecast-wizard-container';
import { CreateForecastWizardContextProvider } from '../contexts/create-forecast-wizard-context';
import { CreateThreeWayForecastWizardContainer } from '../containers/create-3-way-forecast-wizard-container/create-three-way-forecast-wizard-container';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const Create3WayForecastSidebar = ({ isOpen, onClose }: Props) => {
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  return (
    <Sidebar
      header={
        <Typography variant="h2" fontWeight="700">
          <FormattedMessage
            id="predict.create_forecast.create_3_way_forecast_title_v2"
            defaultMessage="Create a 3-way forecast"
          />
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
    >
      {isConsolidation ? (
        <CreateConsolidatedForecastWizardContextProvider kind="scenario">
          <CreateConsolidatedThreeWayForecastContainer onClose={onClose} />
        </CreateConsolidatedForecastWizardContextProvider>
      ) : (
        <CreateForecastWizardContextProvider kind="scenario">
          <CreateThreeWayForecastWizardContainer onClose={onClose} />
        </CreateForecastWizardContextProvider>
      )}
    </Sidebar>
  );
};
